<template>
  <div class="homepageService">
    <content class="service_content">
      <div
        @click="onClickShow('free')"
        class="service_left service_content_block"
      >
        <div class="service_content_describe">
          <strong class="font_weight_500 service_content_describe_title"
            >免费报价</strong
          >
          <span class="service_content_describe_ctx">算算装修要花多少钱</span>
        </div>
        <img
          class="service_content_describe_logo"
          src="./image/calculator.png"
        />
      </div>
      <div
        @click="onClickShow('book')"
        class="service_center service_content_block"
      >
        <div class="service_content_describe">
          <strong class="font_weight_500 service_content_describe_title"
            >预约量房</strong
          >
          <span class="service_content_describe_ctx">免费上门量房</span>
        </div>
        <img class="service_content_describe_logo" src="./image/measure.png" />
      </div>
      <div
        @click="onClickShow('design')"
        class="service_right service_content_block"
      >
        <div class="service_content_describe">
          <strong class="font_weight_500 service_content_describe_title"
            >户型设计</strong
          >
          <span class="service_content_describe_ctx">专业装修方案</span>
        </div>
        <img class="service_content_describe_logo" src="./image/work.png" />
      </div>
    </content>

    <QuotationDialog
      :visible.sync="quotationDialogVisbile"
      :title="companyName + title"
      :content="content"
      :tag="tag"
      :button-text="btnText"
      @click-submit="onClickSubmit"
    />
  </div>
</template>

<script>
import { saveCustomerOrderManager } from '~/api/common.api'
import yqzConstant from '~/constant/target-type.constant'

export default {
  props: {
    companyId: {
      type: [String, Number],
      default: ''
    },
    companyName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      type: '',
      targetType: '',
      entryPoint: '',
      serviceName: '',
      landingPageId: '',
      quotationDialogVisbile: false,
      title: '',
      content: '',
      tag: '',
      btnText: ''
    }
  },
  methods: {
    setData({
      title,
      content,
      tag,
      btnText,
      targetType,
      entryPoint,
      serviceName,
      landingPageId
    }) {
      this.title = title
      this.content = content
      this.tag = tag
      this.btnText = btnText
      this.targetType = targetType
      this.entryPoint = entryPoint
      this.serviceName = serviceName
      this.landingPageId = landingPageId
    },
    onClickShow(type) {
      this.quotationDialogVisbile = true
      this.type = type
      switch (type) {
        case 'free':
          this.setData({
            title: '为你免费报价',
            content:
              '我们将根据你的房屋情况，提供专属报价服务。稍后客服会电话联系你，沟通具体的服务流程',
            tag: '限时免费',
            btnText: '立即获取报价',
            targetType: yqzConstant.COMPANY,
            entryPoint: 'customerService_1',
            serviceName: '装修报价',
            landingPageId: 1
          })
          break
        case 'book':
          this.setData({
            title: '为你预约量房',
            content:
              '免费测量房屋内外尺寸，出装修方案。稍后客服会电话联系你，沟通具体的服务流程',
            tag: '限时免费',
            btnText: '立即预约量房',
            targetType: yqzConstant.COMPANY,
            entryPoint: 'customerService_2',
            serviceName: '免费量房',
            landingPageId: 2
          })
          break
        case 'design':
          this.setData({
            title: '为你户型设计',
            content:
              '根据你的户型结构，有专业设计师提供设计方案。稍后客服会电话联系你，沟通具体的服务流程',
            tag: '专业设计',
            btnText: '立即申请设计',
            targetType: yqzConstant.COMPANY,
            entryPoint: 'customerService_3',
            serviceName: '户型设计',
            landingPageId: 3
          })
          break
      }
    },

    async onClickSubmit(mobile) {
      const res = await saveCustomerOrderManager({
        mobile,
        targetType: this.targetType,
        target: this.companyId,
        entryPoint: this.entryPoint,
        serviceName: this.serviceName,
        landingPageId: this.landingPageId,
        companyId: this.companyId
      })
      if (res.judge) {
        this.$notify({
          message: res.msg,
          type: 'success',
          duration: 3000
        })
      } else {
        this.$notify({
          message: res.msg,
          type: 'warning',
          duration: 3000
        })
      }
      this.quotationDialogVisbile = false
    }
  }
}
</script>
<style lang="scss">
.service_content {
  background: rgba(239, 241, 242, 1);
  display: grid;
  grid-template-columns: calc((100%) / 3) calc((100%) / 3) calc((100%) / 3);
  grid-template-rows: auto;
  .service_left {
    margin-right: calc(20px * 2 / 3);
  }
  .service_center {
    margin: 0px calc(20px * 1 / 3);
  }
  .service_right {
    margin-left: calc(20px * 2 / 3);
  }
  .service_content_block {
    display: flex;
    cursor: pointer;
    justify-content: space-between;
    align-items: center;
    background: white;
    .service_content_describe {
      display: flex;
      justify-content: center;
      flex-flow: column;
      padding-left: 10%;
      .service_content_describe_title {
        font-size: 24px;
        margin-bottom: 8px;
      }
      .service_content_describe_ctx {
        font-size: 14px;
        height: 14px;
        font-weight: 400;
        color: rgba(68, 68, 68, 1);
        line-height: 14px;
      }
    }
    .service_content_describe_logo {
      padding-right: 10%;
      // max-width: 80%;
      // max-height: 80%;
      width: auto;
      height: 80%;
    }
  }
}
@media screen and (min-width: 1250px) {
  .service_content {
    grid-template-rows: 147px;
  }
}
@media screen and (min-width: 940px) and (max-width: 1250px) {
  .service_content {
    grid-template-rows: calc((100vw) / 3 * 102 / 267);
  }
}
@media screen and (max-width: 940px) {
  .service_content {
    display: grid;
    background: white;
    grid-template-columns: calc(50% - 10px) calc(50% + 10px);
    grid-template-rows: 80px 90px;
    .service_center {
      margin: 0 0 0 10px;
      background: rgba(255, 180, 60, 0.1);
    }
    .service_right {
      margin: 10px 0 0 10px;
      background: rgba(56, 136, 255, 0.1);
    }
    .service_left {
      grid-column-start: 1;
      grid-column-end: 2;
      grid-row-start: 1;
      grid-row-end: 3;
      margin-right: 0;

      display: flex;
      flex-direction: column;
      justify-content: center;
      background: rgba(255, 73, 73, 0.1);
      .service_content_describe {
        width: 100%;
      }
      .service_content_describe_logo {
        margin-top: 8px;
        max-width: 60%;
        max-height: 60%;
        width: auto;
        height: auto;
      }
    }
    .service_content_block {
      border-radius: 4px;
      .service_content_describe {
        padding-left: 15px;
        .service_content_describe_title {
          font-size: 16px;
          margin-bottom: 4px;
        }
        .service_content_describe_ctx {
          font-size: 12px;
        }
      }
      .service_content_describe_logo {
        padding-right: 15px;
      }
    }
  }
}
</style>
